import { render } from "./dtedit.vue?vue&type=template&id=0b3c0b2f&scoped=true"
import script from "./dtedit.vue?vue&type=script&lang=js"
export * from "./dtedit.vue?vue&type=script&lang=js"

import "./dtedit.vue?vue&type=style&index=0&id=0b3c0b2f&lang=scss&scoped=true"
import "./dtedit.vue?vue&type=style&index=1&id=0b3c0b2f&scoped=true&lang=css"

import exportComponent from "D:\\workCode\\PC\\web-backEnd\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0b3c0b2f"]])

export default __exports__